import { AbsoluteModelPath, createModelPath } from "../../../../../../Common/ModelPath/ModelPath";
import { ICalculator2 } from "../Calculator2";

import { CalculationFunction } from "./CalculationFunction";

type ModelPathAsString = string;

export class CalculationsBuilder {
    private readonly calculationFunctionsBuilders: CalculationFunctionBuilder[] = [];

    public set(target: ModelPathAsString): CalculationFunctionBuilder {
        const result = new CalculationFunctionBuilder(target);
        this.calculationFunctionsBuilders.push(result);
        return result;
    }

    public applyTo(calculator2: ICalculator2): void {
        for (const calculationFunctionsBuilder of this.calculationFunctionsBuilders) {
            calculator2.addCalculationFunction(calculationFunctionsBuilder.build());
        }
    }
}

type TargetEvaluator = (injection: EvaluatorContext) => string | undefined;

export class CalculationFunctionBuilder {
    private readonly target: ModelPathAsString;
    private readonly dependencies: ModelPathAsString[] = [];
    private targetEvaluator?: TargetEvaluator;

    public constructor(target: ModelPathAsString) {
        this.target = target;
    }

    public dependsOn(...dependencies: ModelPathAsString[]): CalculationFunctionBuilder {
        this.dependencies.push(...dependencies);
        return this;
    }

    public as(targetEvaluator: TargetEvaluator): CalculationFunctionBuilder {
        this.targetEvaluator = targetEvaluator;
        return this;
    }

    public build(): CalculationFunction {
        const targetPath = this.resolveModelPath(this.target);
        if (this.dependencies.length === 0) {
            throw new Error(`У функции автовычисления для ${targetPath.toString()} не объявлено зависимостей`);
        }
        const targetEvaluator = this.targetEvaluator;
        if (targetEvaluator == undefined) {
            throw new Error(`У функции автовычисления для ${targetPath.toString()} не объявлен способ вычисления`);
        }
        return new CalculationFunction(
            targetPath,
            this.dependencies.map(x => this.resolveModelPath(x)),
            context => targetEvaluator({ get: (path: ModelPathAsString) => context.get(this.resolveModelPath(path)) })
        );
    }

    private resolveModelPath(modelPathAsString: ModelPathAsString): AbsoluteModelPath {
        return createModelPath(modelPathAsString, true);
    }
}

interface EvaluatorContext {
    readonly get: (modelPath: ModelPathAsString) => string | undefined;
}
